import type {SectionInserts} from "@/generated/api";
import SectionWrapper from "@/layouts/SectionWrapper";
import InsertCard from "./InsertCard";
import {InsertsWrapper} from "./styles";

interface B8InsertsProps {
  sectionData: SectionInserts;
  isFirstSection?: boolean;
  isLastSection?: boolean;
  id?: string;
}

const B8Inserts = ({sectionData, isFirstSection, isLastSection, id}: B8InsertsProps) => {
  const {bg_color} = sectionData;
  // WordPress answers `false` for a repeater with no row
  const inserts = Array.isArray(sectionData.inserts) ? sectionData.inserts : [];
  const isOneInsert = inserts.length === 1;

  return (
    <SectionWrapper
      id={id}
      backgroundColor={bg_color}
      isFirstSection={isFirstSection}
      isLastSection={isLastSection}
    >
      <InsertsWrapper isOneInsert={isOneInsert}>
        {inserts.length > 0 &&
          inserts.map((insert) => {
            return (
              <InsertCard
                isOneInsert={isOneInsert}
                key={insert.first_part_title}
                cardData={insert}
              />
            );
          })}
      </InsertsWrapper>
    </SectionWrapper>
  );
};

export default B8Inserts;
